import React from 'react'
import Ops from './auth/Ops'; // Need to review to see if it's still needed
import GetStarted from './dashboard/GetStarted'
import Documentation from './dashboard/Documentation'
import Explore from './dashboard/Explore'
import Utilization from './dashboard/Treemap'
import Timeseries from './dashboard/Timeseries'
import Alerts from './dashboard/Alerts'
import AccountSelection from './dashboard/AccountSelection'
import Recommendation from './dashboard/Recommendation'
import Login from './login/Login'
import { useOvermind } from './overmind';

import{
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

export default function App() {
  const { actions } = useOvermind();


  if(window.location.href.indexOf("?debug=true") > -1){
    console.log('Debug Mode Is Activated');
    actions.addFormattedData({'name':'debug', 'payload':true});
  }

  return (

    <Router>
      <div>
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/config">
            <AccountSelection />
          </Route>
          <Route path="/get-started">
            <GetStarted/>
          </Route>
          <Route path="/documentation">
            <Documentation />
          </Route>
          <Route path="/network">
            <Explore />
          </Route>
          <Route path="/utilization">
            <Utilization />
          </Route>
          <Route path="/history">
            <Timeseries />
          </Route>
          <Route path="/audit">
            <Recommendation />
          </Route>
          <Route path="/ops">
            <Ops />
          </Route>
          <Route path="/alerts">
            <Alerts />
          </Route>
          <Route path="/contact-us" component={() => {
               window.location.href = 'https://abovethefold.typeform.com/to/sWgNvErj';
               return null;
          }}/>
          <Route path="/">
            <Login />
          </Route>


        </Switch>
      </div>
    </Router>
  );
}
